<template>
  <div class="gov-live-list">
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 25px;padding-top: 25px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor: pointer;" :to="{ name: 'govInfo' }"
            >政务信息</el-breadcrumb-item
          >
          <el-breadcrumb-item style="color: #009999"
            >直播列表</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="container">
        <div class="gov-video">
          <div class="top-title">
            <div class="live-title">政务直播</div>
            <div class="top-btn">
              <div
                class="btn-com"
                :class="
                  params.stage === item.value ? 'btn-select' : 'btn-normal'
                "
                v-for="item in paramsTypeList"
                @click="onClickType(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div v-if="allList.length > 0" v-loading="dataLoading">
            <div
              class="live-top-box"
              v-if="dataFirst"
              @click="onClickDetail(dataFirst)"
            >
              <div
                class="live-list-img live-top-left"
                style="margin-bottom: 0;"
                :style="{ backgroundImage: `url(${dataFirst.pic})` }"
              >
                <div class="live-list-img-mask"></div>
                <div class="live-list-img-play">
                  <i class="el-icon-video-play"></i>
                </div>
              </div>
              <div
                class="live-list-img live-top-right"
                style="margin-bottom: 0;"
                :style="{ backgroundImage: `url(${govInfoLiveUrl})` }"
              >
                <div style="padding: 20px 30px;">
                  <div style="display: flex;margin-top: 10px;">
                    <div class="over-num-lines live-bottom-title">
                      {{ dataFirst.title }}
                    </div>
                    <div
                      v-if="dataFirst.stage === 'NOT_START'"
                      class="live-bottom-status"
                      style="background: #ff7300;"
                    >
                      <span>未开始</span>
                    </div>
                    <div
                      v-else-if="dataFirst.stage === 'DOING'"
                      class="live-bottom-status"
                    >
                      <span>直播中</span>
                    </div>
                    <div
                      v-else-if="dataFirst.stage === 'END'"
                      class="live-bottom-status"
                      style="background: #808080;"
                    >
                      <span>直播结束</span>
                    </div>
                  </div>
                  <div class="over-num-lines over-2-lines live-bottom-des">
                    {{ dataFirst.summary }}
                  </div>
                  <div class="live-bottom-date">
                    直播时间：{{ dataFirst.startDate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wow animate__animated animate__fadeIn live-list-list">
              <el-row :gutter="45">
                <div
                  v-for="(item, index) in dataList"
                  @click="onClickDetail(item)"
                >
                  <el-col class="live-list-item-box" :span="6">
                    <div
                      class="live-list-img"
                      :style="{ backgroundImage: `url(${item.pic})` }"
                    >
                      <div class="live-list-img-mask"></div>
                      <div class="live-list-img-play">
                        <i class="el-icon-video-play"></i>
                      </div>
                      <div
                        v-if="item.stage === 'NOT_START'"
                        class="live-list-tag"
                      >
                        <span style="background: #ff7300;">未开始</span>
                      </div>
                      <div
                        v-else-if="item.stage === 'DOING'"
                        class="live-list-tag"
                      >
                        <span>直播中</span>
                      </div>
                      <div
                        v-else-if="item.stage === 'END'"
                        class="live-list-tag"
                      >
                        <span style="background: #808080;">直播结束</span>
                      </div>
                    </div>
                    <div class="over-num-lines live-list-bottom-title">
                      {{ item.title }}
                    </div>
                    <div
                      class="over-num-lines over-2-lines live-list-bottom-des"
                    >
                      {{ item.summary }}
                    </div>
                    <div class="over-num-lines live-list-bottom-date">
                      {{ item.startDate }}
                    </div>
                  </el-col>
                </div>
              </el-row>
            </div>
          </div>
          <div v-else style="text-align:center;padding:20px 0;">
            <img
              src="../../assets/nosearchMesg.jpg"
              alt=""
              style="width:200px"
            />
          </div>
        </div>
        <div
          style="text-align: center;padding: 10px 0;"
          v-if="allList.length > 0"
        >
          <el-pagination
            @current-change="onChangeCurrent"
            :current-page="params.current"
            :page-size="params.pageSize"
            background
            layout="prev, pager, next"
            :total="params.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGovHomeLiveList } from "../../utils/interface"

export default {
  //   政务直播列表页
  name: "saasList",
  metaInfo: {
    title: "政务直播-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台政务直播提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      govInfoLiveUrl: require("../../assets/govInfoLive.png"),
      params: {
        stage: "",
        status: "1",
        current: 1,
        pageSize: 15,
        total: 0,
      },
      allList: [],
      dataList: [],
      dataFirst: null,
      dataLoading: false,
      paramsTypeList: [
        { title: "全部", value: "" },
        { title: "未开始", value: "NOT_START" },
        { title: "直播中", value: "DOING" },
        { title: "已结束", value: "END" },
      ],
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataLoading = true
      getGovHomeLiveList(this.params)
        .then((res) => {
          this.dataLoading = false
          this.params.total = res.total
          if (res.list) {
            this.allList = res.list
            this.showListType()
          } else {
            this.allList = []
            this.dataFirst = null
          }
        })
        .catch((err) => {
          this.dataLoading = false
        })
    },
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        path: "/govPlayDetail",
        query: {
          uuid: item.uuid,
          type: "live",
          titleName: "直播列表",
          titleForm: "govLiveList",
        },
      })
      window.open(routeData.href, "_blank")
    },
    onClickType(item) {
      this.params.stage = item.value
      this.getDataList()
    },
    showListType() {
      this.dataFirst = null
      this.dataList = []
      this.dataList = JSON.parse(JSON.stringify(this.allList))
      //全部和直播中，有正在直播的数据时，默认展示第一条
      if (this.params.stage === "DOING" || this.params.stage === "") {
        if (this.allList[0] && this.allList[0].stage === "DOING") {
          this.dataFirst = this.allList[0]
          this.dataList.splice(0, 1)
        }
      }
    },
    onChangeCurrent(e) {
      this.params.current = e
      this.getDataList()
    },
  },
}
</script>

<style scoped lang="less">
@basic-colors: #009999;

.gov-live-list {
  background: #ffffff;

  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }

  .over-2-lines {
    -webkit-line-clamp: 2;
  }

  .over-3-lines {
    -webkit-line-clamp: 3;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .gov-video {
    margin-top: 20px;

    .top-title {
      display: flex;
      justify-content: space-between;
    }

    .top-btn {
      display: flex;
    }

    .btn-com {
      width: 70px;
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      margin-left: 12px;
      font-size: 14px;
      transition: all 0.2s;
    }

    .btn-normal {
      border: 1px solid #777777;
      color: #777777;
      width: 69px;
      height: 29px;
    }

    .btn-select {
      color: white;
      background-color: @basic-colors;
    }

    .live-title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
    }

    .live-top-box {
      display: flex;
      padding: 0 80px;
      margin: 30px 0 0 0;
      color: white;
    }

    .live-top-left {
      width: 400px !important;
      height: 250px !important;
    }

    .live-top-right {
      width: 640px !important;
      height: 200px !important;
      margin-top: 25px !important;
    }

    .live-bottom-title {
      font-size: 26px;
      font-weight: bold;
      max-width: 90%;
    }

    .live-bottom-status {
      font-size: 14px;
      height: 21px;
      line-height: 21px;
      padding: 1px 2px;
      background: #e63e1d;
      border-radius: 8px;
      border: 1px solid #ffffff;
      margin: auto 15px;
    }

    .live-bottom-des {
      margin-top: 12px;
      font-size: 14px;
      line-height: 24px;
      height: 48px;
    }

    .live-bottom-date {
      margin-top: 15px;
      font-size: 16px;
      line-height: 24px;
    }

    .live-list-list {
      margin-top: 35px;
    }

    .live-list-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 290px;
      height: 170px;
      margin-bottom: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      //box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
    }

    .live-list-item-box:hover {
      .live-list-img {
        transform: scale(1.02);
      }

      .live-list-bottom-title {
        color: @basic-colors;
      }
    }

    .live-list-img-mask {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .live-list-img-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #cccccc;
      //background-color: #526396;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      font-size: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .live-list-tag {
      width: 90px;
      height: 90px;
      position: absolute;
      top: -45px;
      right: -45px;
      transform: rotate(45deg);
    }

    .live-list-tag span {
      position: absolute;
      bottom: 0;
      padding: 2px 0 3px 0;
      display: block;
      font-size: 12px;
      color: #fff;
      background: #ff3526;
      width: 90px;
      text-align: center;
    }

    .live-list-bottom-title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 7px;
    }

    .live-list-bottom-des {
      font-size: 14px;
      color: #9f9f9f;
      margin-bottom: 7px;
      height: 38px;
    }

    .live-list-bottom-date {
      font-size: 14px;
      color: #333333;
      margin-bottom: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/liveList.vue